import { combineSlices } from "@reduxjs/toolkit";
import loginReducer from "./login/loginSlice";
import doctorAppointmentsReducer from "./appointments/doctorAppointmentsSlice";
import fetchDoctorAppointmentsReducer from "./appointments/doctorAppointmentsSlice";
import updateOnsiteScheduleReducer from "./updateOnsiteSchedule/updateOnsiteScheduleSlice";
import requestAppointmentRescheduleReducer from "./requestAppointmentReschedule/requestAppointmentRescheduleSlice";
import createFollowupAppointmentReducer from "./createFollowupAppointment/createFollowupAppointmentSlice";
import notificationsReducer from "./notifications/notificationsSlice";
import imagingEarningsReducer from "./imagingEarnings/imagingEarningsSlice";
import imagingOrdersReducer from "./imagingOrders/imagingOrdersSlice";
import imagingTechniciansReducer from "./imagingTechnicians/imagingTechniciansSlice";
import payoutAccountReducer from "./payoutAccount/payoutAccountSlice";

export default combineSlices({
  login: loginReducer,
  appointments: doctorAppointmentsReducer,
  fetchDoctorAppointments: fetchDoctorAppointmentsReducer,
  updateOnsiteSchedule: updateOnsiteScheduleReducer,
  requestAppointmentReschedule: requestAppointmentRescheduleReducer,
  createFollowupAppointment: createFollowupAppointmentReducer,
  notifications: notificationsReducer,
  imagingEarnings: imagingEarningsReducer,
  imagingOrders: imagingOrdersReducer,
  imagingTechnicians: imagingTechniciansReducer,
  payoutAccount: payoutAccountReducer,
});
